<script>
import { teststore } from './teststore.js';

export default {
  props: ['item', 'index'],
  
  data() {
    return {
      teststore,
      "lframe": {},
      dir: false,
    }
  },

  mounted() {
    Object.assign(this.lframe, this.item.frame);
    this.$refs.ogpi.style = this.generateStyle();
  },

  updated() {
    Object.assign(this.lframe, this.item.frame);
    this.$refs.ogpi.style = this.generateStyle();
  },  

  methods: {

    hexToRgbA(hex, opac){
      var c;
      var rgba = 0;
      if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
          c= hex.substring(1).split('');
          if(c.length== 3){
              c= [c[0], c[0], c[1], c[1], c[2], c[2]];
          }
          c= '0x'+c.join('');
          
          rgba = Math.round((opac / 100) * 100) / 100;
      
          return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',' + rgba +')';
      }
    },

    generateStyle() {
        var rotationnum = !isNaN(parseInt(this.lframe.rotate))?parseInt(this.lframe.rotate):0;
        var widthnum = !isNaN(parseInt(this.lframe.width))?parseInt(this.lframe.width):0;
        var heightnum = !isNaN(parseInt(this.lframe.height))?parseInt(this.lframe.height):0;
        var translatexnum = !isNaN(parseInt(this.lframe.translatex))?parseInt(this.lframe.translatex):0;
        var translateynum = !isNaN(parseInt(this.lframe.translatey))?parseInt(this.lframe.translatey):0;

        var stylestr = `transform: translate(${translatexnum}px, ${translateynum}px) 
            rotate(${rotationnum}deg);
            width: ${widthnum}px;
            height: ${heightnum}px; `;

        if (this.item.type == "image"){
            stylestr = `transform: translate(${translatexnum}px, ${translateynum}px) 
            rotate(${rotationnum}deg);
            width: ${widthnum}px;
            height: auto; `;
        }
        return stylestr;
    },
  },

  computed: {

    dynamicOuterClass() {
      var output ='opengraphiqitem ';
      output += this.item.basicouterclass;
      output += this.item.outerclass;
      return output;
    },

    dynamicInnerClass() {
      var output ='';
      output += this.item.basicinnerclass + ' ';
      output += this.item.innerclass;
      return output;
    },

    dynamicImageStyles() {
      var output = ''; 
      if (this.item.backgroundimage != '' ) output += ' --bg-image: url("' + this.item.backgroundimage +'");';
      if (this.item.bordercolor != '' ) output += ' --og-border-color: ' + this.item.bordercolor +';'
      if (this.item.borderstyle != '' ) output += ' --og-border-style: ' + this.item.borderstyle + ';';
      output += ' --og-border-width: ' + this.item.borderwidth +'px;'
      if (this.item.borderradius > 0 ) output += ' --og-border-radius: ' + this.item.borderradius +'px;'
      return  output;
    },

    imageStyles() {
      var output = ''; 
      if (this.item.bordercolor != '' ) output += ' --og-border-color: ' + this.item.bordercolor +';'
      if (this.item.borderstyle != '' ) output += ' --og-border-style: ' + this.item.borderstyle + ';';
      output += ' --og-border-width: ' + this.item.borderwidth +'px;'
      if (this.item.borderradius > 0 ) output += ' --og-border-radius: ' + this.item.borderradius +'px;'
      return  output;
    },

    dynamicTextStyles() {
      var output = '';
      if (this.item.color != '' ) output += ' --text-color: ' + this.hexToRgbA(this.item.color, this.item.opacity) +';';
      if (this.item.fontsize > 0 ) output += ' --font-size: ' + this.item.fontsize +'px;'
      if (this.item.fontstyle != '' ) output += ' --og-font-style: ' + this.item.fontstyle +';'
      if (this.item.fontfamily != '') output += ' --font-family: "' + this.item.fontfamily.replace(new RegExp("\\+","g"),' ') + '";'
      if (this.item.fontweight > 0 ) output += ' --font-weight: ' + this.item.fontweight + ';';
      if (this.item.texttransform != '') output += ' --text-transform: ' + this.item.texttransform + ';';
      if (this.item.verticalalign != '') output += ' --align-self: ' + this.item.verticalalign + ';';
      if (this.item.horizontalalign != '') output += ' --align: ' + this.item.horizontalalign + ';';
      if (this.item.decorationline !== undefined && this.item.decorationline.length != 0) output += ' --og-text-decoration-line: ' + this.item.decorationline.join(' ') + ';'; 
      //if (this.item.decorationthickness > 0 ) output += ' --og-text-decoration-thickness: ' + this.item.decorationthickness + 'px;'
      //if (this.item.decorationstyle != '' ) output += ' --og-text-decoration-style: ' + this.item.decorationstyle + ';'
      //if (this.item.decorationcolor != '' ) output += ' --og-text-decoration-color: ' + this.item.decorationcolor +';'
      if (this.item.hshadow != 0 || this.item.vshadow != 0){
        output += ' --og-text-shadow: ' + this.item.hshadow +'px ';
        output +=  this.item.vshadow +'px ';
        output +=  this.item.radiusshadow +'px ';
        output += this.hexToRgbA(this.item.colorshadow, this.item.opacityshadow) + ';' ;
      }
      if (this.item.bgcolor != '' ) output += ' --og-background-color: ' + this.hexToRgbA(this.item.bgcolor, this.item.bgopacity) +';'
      if (this.item.bordercolor != '' ) output += ' --og-border-color: ' + this.item.bordercolor +';'
      if (this.item.borderstyle != '' ) output += ' --og-border-style: ' + this.item.borderstyle + ';';
      output += ' --og-border-width: ' + this.item.borderwidth +'px;'
      if (this.item.borderradius > 0 ) output += ' --og-border-radius: ' + this.item.borderradius +'px;'
      if (this.item.horizontalpadding > 0 ) output += ' --og-horizontal-padding: ' + this.item.horizontalpadding +'px;'
      if (this.item.verticalpadding > 0 ) output += ' --og-vertical-padding: ' + this.item.verticalpadding +'px;'
      if (this.item.lineheight > 0 ) output += ' --og-line-height: ' +  this.item.lineheight +';'
      return output;
    },

     dynamicDynTextStyles() {
      var output = '';
      if (this.item.color != '' ) output += ' --text-color: ' + this.hexToRgbA(this.item.color, this.item.opacity) +';';
      if (this.item.fontsize != '' ) output += ' --font-size: ' + this.item.fontsize +'px;'
      if (this.item.fontstyle != '' ) output += ' --og-font-style: ' + this.item.fontstyle +';'
      if (this.item.fontfamily != '') output += ' --font-family: "' + this.item.fontfamily.replace(new RegExp("\\+","g"),' ') + '";'
      if (this.item.fontweight != '') output += ' --font-weight: ' + this.item.fontweight + ';';
      if (this.item.texttransform != '') output += ' --text-transform: ' + this.item.texttransform + ';';
      if (this.item.verticalalign != '') output += ' --align-self: ' + this.item.verticalalign + ';';
      if (this.item.horizontalalign != '') output += ' --align: ' + this.item.horizontalalign + ';';
      if (this.item.decorationline !== undefined && this.item.decorationline.length != 0) output += ' --og-text-decoration-line: ' + this.item.decorationline.join(' ') + ';'; 
      //if (this.item.decorationthickness > 0 ) output += ' --og-text-decoration-thickness: ' + this.item.decorationthickness + 'px;'
      //if (this.item.decorationstyle != '' ) output += ' --og-text-decoration-style: ' + this.item.decorationstyle + ';'
      //if (this.item.decorationcolor != '' ) output += ' --og-text-decoration-color: ' + this.item.decorationcolor +';'
      if (this.item.hshadow != 0 || this.item.vshadow != 0){
        output += ' --og-text-shadow: ' + this.item.hshadow +'px ';
        output +=  this.item.vshadow +'px ';
        output +=  this.item.radiusshadow +'px ';
        output += this.hexToRgbA(this.item.colorshadow, this.item.opacityshadow) + ';' ;
      }
      if (this.item.bgcolor != '' ) output += ' --og-background-color: ' + this.hexToRgbA(this.item.bgcolor, this.item.bgopacity) +';'
      if (this.item.bordercolor != '' ) output += ' --og-border-color: ' + this.item.bordercolor +';'
      if (this.item.borderstyle != '' ) output += ' --og-border-style: ' + this.item.borderstyle + ';';
      output += ' --og-border-width: ' + this.item.borderwidth +'px;'
      if (this.item.borderradius > 0 ) output += ' --og-border-radius: ' + this.item.borderradius +'px;'
      if (this.item.horizontalpadding > 0 ) output += ' --og-horizontal-padding: ' + this.item.horizontalpadding +'px;'
      if (this.item.verticalpadding > 0 ) output += ' --og-vertical-padding: ' + this.item.verticalpadding +'px;'
      if (this.item.lineheight > 0 ) output += ' --og-line-height: ' +  this.item.lineheight +';'
      return output;
    },

    dynamicTaxonomyStyles() {
      var output = '';
      if (this.item.color != '' ) output += ' --text-color: ' + this.hexToRgbA(this.item.color, this.item.opacity) +';';
      if (this.item.fontsize != '' ) output += ' --font-size: ' + this.item.fontsize +'px;'
      if (this.item.fontstyle != '' ) output += ' --og-font-style: ' + this.item.fontstyle +';'
      if (this.item.fontfamily != '') output += ' --font-family: "' + this.item.fontfamily.replace(new RegExp("\\+","g"),' ') + '";'
      if (this.item.fontweight != '') output += ' --font-weight: ' + this.item.fontweight + ';';
      if (this.item.texttransform != '') output += ' --text-transform: ' + this.item.texttransform + ';';
      if (this.item.verticalalign != '') output += ' --align-self: ' + this.item.verticalalign + ';';
      if (this.item.horizontalalign != '') output += ' --align: ' + this.item.horizontalalign + ';';
       if (this.item.decorationline !== undefined && this.item.decorationline.length != 0) output += ' --og-text-decoration-line: ' + this.item.decorationline.join(' ') + ';'; 
      //if (this.item.decorationthickness > 0 ) output += ' --og-text-decoration-thickness: ' + this.item.decorationthickness + 'px;'
      //if (this.item.decorationstyle != '' ) output += ' --og-text-decoration-style: ' + this.item.decorationstyle + ';'
      //if (this.item.decorationcolor != '' ) output += ' --og-text-decoration-color: ' + this.item.decorationcolor +';'
      if (this.item.hshadow != 0 || this.item.vshadow != 0){
        output += ' --og-text-shadow: ' + this.item.hshadow +'px ';
        output +=  this.item.vshadow +'px ';
        output +=  this.item.radiusshadow +'px ';
        output += this.hexToRgbA(this.item.colorshadow, this.item.opacityshadow) + ';' ;
      }
      if (this.item.bgcolor != '' ) output += ' --og-background-color: ' + this.hexToRgbA(this.item.bgcolor, this.item.bgopacity) +';'
      if (this.item.bordercolor != '' ) output += ' --og-border-color: ' + this.item.bordercolor +';'
      if (this.item.borderstyle != '' ) output += ' --og-border-style: ' + this.item.borderstyle + ';';
      output += ' --og-border-width: ' + this.item.borderwidth +'px;'
      if (this.item.borderradius > 0 ) output += ' --og-border-radius: ' + this.item.borderradius +'px;'
      if (this.item.horizontalpadding > 0 ) output += ' --og-horizontal-padding: ' + this.item.horizontalpadding +'px;'
      if (this.item.verticalpadding > 0 ) output += ' --og-vertical-padding: ' + this.item.verticalpadding +'px;';
      if (this.item.lineheight > 0 ) output += ' --og-line-height: ' +  this.item.lineheight +';'
      if (this.item.itembgcolor != '' ) output += ' --og-taxonomy-item-background-color: ' + this.hexToRgbA(this.item.itembgcolor, this.item.itembgopacity) + ';';
      if (this.item.itempaddingleft > 0 ) output += ' --og-taxonomy-item-padding-horizontal: ' + this.item.itempaddingleft +'px;';
      if (this.item.itempaddingright > 0 ) output += ' --og-taxonomy-item-padding-vertical: ' + this.item.itempaddingright +'px;';
      if (this.item.itemborderradius > 0 ) output += ' --og-taxonomy-item-border-radius: ' + this.item.itemborderradius +'px;';
      return output;
    },

     dynamicRectStyles() {
      var output = '';
      
      if (this.item.bgcolor != '' ) output += ' --og-background-color: ' + this.hexToRgbA(this.item.bgcolor, this.item.bgopacity) +';'

      if (this.item.bordercolor != '' ) output += ' --og-border-color: ' + this.item.bordercolor +';'
      if (this.item.borderstyle != '' ) output += ' --og-border-style: ' + this.item.borderstyle + ';';
      output += ' --og-border-width: ' + this.item.borderwidth +'px;' 
      if (this.item.borderradius > 0 ) output += ' --og-border-radius: ' + this.item.borderradius +'px;'
      return output;
    },

    generateTarget(){
      var t = [];
      t.push('#ogpaintitem' + this.item.id);
      return t;
    }
  }
};
</script>

<template>

  <div v-if="item.type == 'rect'" :data-id="item.id" data-type = "rect" :class="this.dynamicOuterClass" ref="ogpi" >
      <div :class="this.dynamicInnerClass" :style="dynamicRectStyles">
      </div>
  </div>

  <div v-if="item.type == 'dynimage'" :data-id="item.id" data-type = "dynimg" :class="this.dynamicOuterClass" ref="ogpi" >
    <div :class="this.dynamicInnerClass" :style="dynamicImageStyles">
    </div>
  </div>

  <div v-if="item.type == 'image'" :data-id="item.id" data-type="image" :class="this.dynamicOuterClass" ref="ogpi" >
      <div :class="this.dynamicInnerClass" :style="imageStyles">
        <img :src="item.src" class="ogimginnerimg" @load="onImgLoad">
      </div>
  </div>

  <div v-if="item.type == 'text'"  data-type="text" :data-id="item.id" :class="this.dynamicOuterClass" ref="ogpi" >
      <div :class="this.dynamicInnerClass" :style="dynamicTextStyles">
          {{item.caption}}
      </div>
  </div>

  <div v-if="item.type == 'dyntext'" data-type="dyntext" :data-id="item.id"  :class="this.dynamicOuterClass" ref="ogpi" >
      <div :class="this.dynamicInnerClass" :style="dynamicDynTextStyles" v-html="item.caption">
      </div>
  </div>

  <div v-if="item.type == 'taxonomy'" data-type="taxonomy" :data-id="item.id"  :class="this.dynamicOuterClass" ref="ogpi" >
      <div :class="this.dynamicInnerClass" :style="dynamicTaxonomyStyles">
        <template v-for="(tax, taxind) in item.dynarray" :key="taxind">
          <span class="og-taxonomy-element">{{tax}}</span><span :data-separator="item.itemcontent" class="og-taxonomy-separator"></span>
        </template>
      </div>
  </div>

</template>